import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

export default function setBannersLinha() {
  const sections = document.querySelectorAll('[data-banner-linha]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');

    new Swiper(carousel, {
      modules: [Pagination, Autoplay],
      slidesPerView: 1.2,
      spaceBetween: 8,
      watchOverflow: true,
      speed: prefersReducedMotion ? 1000 : 6500,
      loop: !prefersReducedMotion,
      loopAdditionalSlides: 4,
      autoplay: prefersReducedMotion
        ? false
        : {
            delay: 0,
            disableOnInteraction: false, 
            pauseOnMouseEnter: false,
          },
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });
  });
}
